<template>
  <div>
    <a-form class="mb-4" :form="form">
        <a-spin :spinning="spinning">
      <div class="row pb-3">
        <div class="col-md-4">
          <a-form-item label="Start Date">
            <a-date-picker
              v-decorator="[
                'start_date',
                {
                  rules: [
                    { required: true, message: 'Please input a start date' },
                  ],
                  initialValue: undefined,
                },
              ]"
              :format="dateFormat"
              size="large"
              style="width: 100%"
              placeholder= 'select start date'
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item label="End Date">
            <a-date-picker
              v-decorator="[
                'end_date',
                {
                  rules: [
                    { required: true, message: 'Please input an end date' },
                  ],
                  initialValue: undefined,
                },
              ]"
              :format="dateFormat"
              size="large"
              style="width: 100%;"
              placeholder= 'select end date'
            />
          </a-form-item>
        </div>
        <div class="col-md-3">
          <div style="margin-top:25px">
              <button
            @click="handleSubmit"
            type="button"
            class="btn btn-primary btn-with-download"
          >
            <span class="btn-addon"
              ><i class="btn-addon-icon fe fe-download"></i
            ></span>
            Export
          </button>
        </div>
        </div>
      </div>
        </a-spin>
    </a-form>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'AddApplicationForm',
  mounted: function () {
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      spinning: false,
      dateFormat: 'YYYY-MM-DD',
    }
  },
  props: ['formId'],
  computed: {
    currentFormId: function () {
      return this.formId
    },
  },
  methods: {
    moment,
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let startDate = moment(values.start_date).format(this.dateFormat)
          let endDate = moment(values.end_date).format(this.dateFormat)
          this.spinning = true
          this.$http
            .post(
              `/api/online-applicants/export/${this.currentFormId}`,
              {
                start_date: startDate,
                end_date: endDate,
              },
              {
                responseType: 'arraybuffer',
              }
            )
            .then((response) => {
              this.spinning = false
              let blob = new Blob([response.data], {
                type: 'application/json',
              })
              this.loading = false
              this.$notification['info']({
                message: 'Applicant export',
                description: `Applicant export has started! You will be notified once it is completed!`,
              })

              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = 'Applicants-Export.xlsx'
              link.click()
              this.form.resetFields()
            })
            .catch((error) => {
              this.spinning = true
              this.loading = false
              this.$neoNotify.error(error)
            })
        }
      })
    },

  },
}
</script>
